import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button, Divider } from '@material-ui/core';
import classNames from 'classnames';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { injectIntl } from 'react-intl';
import messages from 'aurora-translations';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { numberMaskWithoutDecimalOption } from 'aurora-utils/constants';
import ADGMTextField from '../ADGMTextField';

import styles from './styles';

function FetchPremiseAddress({
  intl,
  classes,
  premiseNumber,
  premiseAddress,
  required,
  onChangeHandler,
  fetchPremiseHandler,
  customClasses,
}) {
  return (
    <div className={classNames(classes.container, customClasses?.container)}>
      <div className={classes.premiseContainer}>
        <ADGMTextField
          id='premiseNumber'
          name='premiseNumber'
          value={premiseNumber}
          label={keyEmptyCheck('premise_id')}
          placeholder={intl.formatMessage({ ...messages.enter_premise_id })}
          onChange={onChangeHandler}
          required={required}
          mask={createNumberMask(numberMaskWithoutDecimalOption)}
          customClasses={{ container: classes.premiseFieldContainer }}
        />
        <Button
          variant='outlined'
          className={classes.fetchDetailsBtn}
          onClick={fetchPremiseHandler}
          disabled={typeof fetchPremiseHandler !== 'function'}
          size='large'
        >
          {keyEmptyCheck('fetch_details')}
        </Button>
      </div>
      <Typography component='p' className={classes.hint}>
        {keyEmptyCheck('enter_premise_id_fetch_unit_details')}
      </Typography>
      <Divider className={classes.divider} />
      {/* <ADGMItemDetails label='premise_address' value={form?.premisesAddress} /> */}
      <div className={classes.premiseAddressContainer}>
        <Typography component='p' className={classes.premiseAddressLabel}>
          {keyEmptyCheck('premise_address')}
        </Typography>
        <Typography component='h2' className={classes.premiseAddress}>
          {premiseAddress}
        </Typography>
      </div>
    </div>
  );
}

FetchPremiseAddress.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  premiseNumber: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
  premiseAddress: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChangeHandler: PropTypes.func.isRequired,
  fetchPremiseHandler: PropTypes.func.isRequired,
  customClasses: PropTypes.object,
};

FetchPremiseAddress.defaultProps = {
  required: false,
  customClasses: {},
};

export default withStyles(styles)(injectIntl(FetchPremiseAddress));
